<template>
  <object
      :data="url"
      type="application/pdf"
      width="100%"
      height="100%"
  >
  </object>
</template>

<script>
  export default {
    name: 'InlinePdf',
    props: {
      'url': String,
      'fallbackMessage': String,
    }
  }
</script>
